import React, { useState } from "react";
import type { MediaFile } from "../shared/types";

/**
 * A picture or video the API published for the docs (examples, changelog frames). The file line carries
 * no dimensions, so the media keeps its own aspect at full width; `alt` is what is shown; a picture
 * opens larger on click.
 */
export const Media = ({ file, alt }: { file: MediaFile; alt: string }) => {
  const [zoomed, setZoomed] = useState(false);
  if (file.media_type.startsWith("video/")) {
    return <video src={file.url} poster={file.poster_url ?? undefined} controls preload="none" className="h-auto w-full rounded-lg border border-border" />;
  }
  if (!file.media_type.startsWith("image/")) {
    return (
      <a href={file.url} target="_blank" rel="noopener noreferrer" className="text-bodySmall underline">
        {alt}
      </a>
    );
  }

  return (
    <>
      <button type="button" onClick={() => setZoomed(true)} className="block w-full" aria-label={alt}>
        <img src={file.url} alt={alt} loading="lazy" className="h-auto w-full rounded-lg border border-border" />
      </button>
      {zoomed ? (
        <button type="button" onClick={() => setZoomed(false)} className="fixed inset-0 z-50 flex items-center justify-center bg-trueBlack/80 p-6" aria-label={alt}>
          <img src={file.url} alt={alt} className="max-h-full max-w-full rounded-lg" />
        </button>
      ) : null}
    </>
  );
};
